module.exports = __webpack_public_path__ + "img/mainImg.323d857b.png";